import { Scrollbars } from 'rc-scrollbars';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MoonLoader } from 'react-spinners';

function MonitTable({ dataStructures, selSensorIdx, selDataIdx, formData, onChangeInput, isEditMode, loading, setLoading }) {
    const [fullDatas, setFullDatas] = useState([]);
    const [loadedData, setLoadedData] = useState([]);
    const [stopGetMore, setStopGetMore] = useState(false);
    const limit = 50;
    const [page, setPage] = useState(1)
    const offset = (page - 1) * limit;
    const data = { ...formData[0] };
    const valView = dataStructures[selSensorIdx]["valView"];
    const tableH = 28 * (valView.reduce((cnt, element) => cnt + (element ? 1 : 0), 0) + 1) + 16;
    const count = Object.keys(data).length - 2;
    const grpNameArr = [...dataStructures[selSensorIdx].indexName];
    const scrollbarRef = useRef();


    const handleObserver = (entries) => {
        const target = entries[0];
        if (target.isIntersecting && loadedData.length >= 50 && !stopGetMore) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const obsRef = useRef();
    useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, { threshold: 0.5 });
        if (obsRef.current) observer.observe(obsRef.current);
        return () => { observer.disconnect(); }
    }, [handleObserver]);
    useEffect(() => {
        setFullDatas([...formData]);
        const initData = formData.slice(0, limit);
        setLoadedData([...initData])
    }, [formData]);
    useEffect(() => {
        setPage(1);
        scrollbarRef.current?.scrollToLeft();
    }, [selSensorIdx, selDataIdx]);
    useEffect(() => {
        if (page !== 1) {
            const nextData = fullDatas.slice(offset, offset + limit);
            setLoadedData(prev => [...prev, ...nextData]);
            setStopGetMore(true);
            setTimeout(() => {
                setStopGetMore(false);
            }, 200);
        }
    }, [page]);

    return (
        // loading ? <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        //     <MoonLoader color='#0A2B83' size={40} />
        // </div> :
        <div className='monitTbl'>
            <div className='thead'>
                <ul>
                    <li className='row th'><div>{"time"}</div></li>
                    {
                        grpNameArr.map((el, idx) => {
                            if (valView[idx]) {
                                return (<li className='row th' key={idx}><div>{el}</div></li>)
                            }
                        })
                    }
                </ul>
            </div>
            <div className='tbody'>
                <Scrollbars style={{ width: '100%', height: `${tableH}px` }} id='scrollArea' ref={scrollbarRef}>
                    <ul className='tbodyUl'>
                        {
                            loadedData.map((el, index) => {
                                return (<MemoizedDataCol key={index} el={el} index={index} isEditMode={isEditMode} onChangeInput={onChangeInput} indexTypes={dataStructures[selSensorIdx].indexType} valView={valView} />);
                            })
                        }
                        {/* {
                            dataColLoading && <li><MoonLoader color='#0A2B83' size={15} /></li>
                        } */}
                        <li>
                            <div id='observer' style={{ width: "50px", height: "100%" }} ref={obsRef} />
                        </li>
                    </ul>
                </Scrollbars>
            </div>
        </div>
    );
}

function DataCol({ el, index, isEditMode, onChangeInput, indexTypes, valView }) {
    const { time, id, ...rest } = el;
    return (
        <li className='col' key={id}>
            <div>
                <ul>

                    <li className='row'>
                        <InputComponent el={el} index={index} name={`time`} onChangeInput={onChangeInput} isDisabled={!isEditMode} />
                    </li>
                    {Object.keys(rest).map((element, idx) => {
                        if (valView[idx]) {
                            return (<li className='row' key={idx}>
                                <InputComponent el={el} index={index} name={element} onChangeInput={onChangeInput} isDisabled={!isEditMode} indexType={indexTypes[idx]} />
                            </li>);
                        }
                    })}
                </ul>
            </div>
        </li>
    );
}

const MemoizedDataCol = React.memo(DataCol);

function InputComponent({ el, index, name, onChangeInput, isDisabled, indexType }) {
    const [isFocused, setIsFocused] = useState(false);
    const onFocus = e => {
        setIsFocused(true);
    };
    const onBlur = e => {
        setIsFocused(false);
    }
    return (
        <input type='number' name={name} value={indexType === 'TINYINT' ? parseInt(el[name]) : isFocused ? parseFloat(el[name]) : parseFloat(el[name]).toFixed(3)} onFocus={onFocus} onBlur={onBlur} onChange={e => onChangeInput(e, index, name)} disabled={isDisabled} />
    )
}

export default MonitTable;